import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

const ListOfEntitiesStyles = makeStyles((theme: Theme) =>
    createStyles({
        header: {
            display: "flex",
            alignItems: "center",
            paddingBottom: theme.spacing(0.5),
            marginTop: theme.spacing(1.5),
        },
        title: {
            flex: "1 1 55%",
            fontSize: 10,
            letterSpacing: "1px",
            paddingLeft: theme.spacing(1),
            color: theme.palette.text.disabled,
            textTransform: "uppercase",
            textAlign: "right",
            marginLeft: "auto",
        },
        body: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            maxHeight: 300,
            overflowY: "scroll",
        },
        item: {
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #DADEE5",
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
        },
        termColumn: {
            flex: "1 1 45%",
            borderRight: "1px solid #DADEE5",
        },
        headerColumn: {
            flex: "0 0 45%",
        },
        term: {
            fontSize: 12,
            textTransform: "capitalize",
        },
        subTerm: {
            fontSize: 10,
        },
        valueColumn: {
            flex: "1 1 55%",
            fontSize: 10,
            letterSpacing: "0.43px",
            paddingLeft: theme.spacing(1),
        },
        columnName: {
            fontSize: 10,
            fontWeight: 400,
            color: theme.palette.text.disabled,
        },
    })
);

export default ListOfEntitiesStyles;
